import React from "react";
import { Link } from "react-router-dom";
import { ORG } from "../../data/costant";

const About = () => {
  return (
    <div className="container-fluid overflow-hidden py-5 px-lg-0">
      <div className="container about py-5 px-lg-0">
        <div className="row g-5 mx-lg-0">
          {/* Left Column with Image */}
          <div
            className="col-lg-6 ps-lg-0 wow fadeInLeft"
            data-wow-delay="0.1s"
            style={{ minHeight: "400px" }}
          >
            <div className="position-relative h-100">
              <img
                className="position-absolute img-fluid w-100 h-100"
                src="/assets/img/about.jpg"
                alt=""
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
          {/* Right Column with Text */}
          <div
            className="col-lg-6 about-text wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <h6 className="text-secondary text-uppercase mb-3">About Us</h6>
            <h1 className="mb-3">Quick Transport and Logistics Solutions</h1>
            <p className="mb-5">
              Welcome to {ORG.name}, your trusted partner in transport and
              logistics solutions. With years of experience in the industry, we
              pride ourselves on delivering reliable, efficient, and customized
              services tailored to meet the unique needs of businesses and
              individuals. Our mission is to bridge distances and connect
              businesses by providing seamless logistics solutions that ensure
              timely and safe deliveries. Whether you need to move goods across
              the city or country, we have the expertise and resources
              to get the job done. We are committed to excellence, leveraging
              cutting-edge technology, a dedicated team, and a customer-centric
              approach to redefine the logistics experience. At
              {ORG.name}, your satisfaction drives us to go the extra mile.
            </p>
            <div className="row g-4 mb-5">
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.5s">
                <i className="fa fa-map-marker-alt fa-3x text-primary mb-3"></i>
                <h5>Service Coverage</h5>
                <p className="m-0">
                  Connecting businesses with efficient, reliable, and seamless
                  transport and logistics solutions across our service areas.
                </p>
              </div>
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.7s">
                <i className="fa fa-shipping-fast fa-3x text-primary mb-3"></i>
                <h5>On Time Delivery</h5>
                <p className="m-0">
                  Ensuring your shipments arrive safely and punctually, every
                  time, with our reliable and efficient logistics solutions.
                </p>
              </div>
            </div>
            <Link to={"/newQuote"} className="btn btn-primary py-3 px-5">
              Explore More
            </Link>
          </div>
        </div>
        <div className="mt-5 container">
          <div className="row g-4 mt-5 mb-5">
            <div className="col-sm-3 wow fadeIn" data-wow-delay="0.5s">
              <i className="fa fa-hand-point-up fa-3x text-primary mb-3"></i>
              <h5>Our Mission</h5>
              <p className="m-0">
                At Nexways, our mission is to provide reliable and affordable
                transportation services to our clients. We strive to exceed your
                expectations with our exceptional service and attention to
                detail
              </p>
            </div>
            <div className="col-sm-3 wow fadeIn" data-wow-delay="0.7s">
              <i className="fa fa-map-marker-alt fa-3x text-primary mb-3"></i>
              <h5>Our Coverage</h5>
              <p className="m-0">
                We provide transportation services throughout the entire city
                metropolitan area. Our coverage includes all major airports,
                hotels, and tourist destinations.
              </p>
            </div>
            <div className="col-sm-3 wow fadeIn" data-wow-delay="0.7s">
              <i className="fa fa-laptop fa-3x text-primary mb-3"></i>
              <h5>Our Technology</h5>
              <p className="m-0">
                We use the latest technology to ensure a seamless booking and
                travel experience for our clients. Our online booking system
                allows you to easily book and manage your transportation
                services.
              </p>
            </div>
            <div className="col-sm-3 wow fadeIn" data-wow-delay="0.7s">
              <i className="fa fa-heart fa-3x text-primary mb-3"></i>
              <h5>Our Sustainability</h5>
              <p className="m-0">
                At Nexways, we are committed to reducing our environmental
                impact. We use fuel-efficient vehicles and implement
                eco-friendly practices in our operations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
